/** Seeded support categories (no list API in backend MVP). */
export const SUPPORT_CATEGORIES = [
  { slug: 'login', name: 'Login' },
  { slug: 'ai-tutor', name: 'AI Tutor' },
  { slug: 'communication-tutor', name: 'Communication Tutor' },
  { slug: 'scenario-conversation', name: 'Scenario Conversation' },
  { slug: 'assignments', name: 'Assignments' },
  { slug: 'billing', name: 'Billing' },
  { slug: 'subscription', name: 'Subscription' },
  { slug: 'weekly-reports', name: 'Weekly Reports' },
  { slug: 'bug', name: 'Bug' },
  { slug: 'feature-request', name: 'Feature Request' },
  { slug: 'other', name: 'Other' },
] as const;

export const TICKET_STATUSES = [
  'OPEN',
  'IN_PROGRESS',
  'WAITING_CUSTOMER',
  'RESOLVED',
  'CLOSED',
] as const;

export const TICKET_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'URGENT'] as const;

export const TICKET_TYPES = [
  'QUESTION',
  'INCIDENT',
  'BUG',
  'FEATURE_REQUEST',
  'TASK',
] as const;

export function categoryLabel(slug: string): string {
  const normalized = slug.replace(/_/g, '-');
  const found = SUPPORT_CATEGORIES.find((c) => c.slug === normalized || c.slug === slug);
  return found?.name ?? slug;
}

export function getSupportBasePath(roles: readonly string[]): string {
  if (roles.includes('DEV_TEAM')) return '/dev/support';
  if (roles.includes('SCHOOL_ADMIN')) return '/admin/support';
  if (roles.includes('TEACHER')) return '/teacher/support';
  if (roles.includes('PARENT')) return '/parent/support';
  if (roles.includes('STUDENT')) return '/student/support';
  return '/admin/support';
}
